
import { Button } from "@/components/ui/button";
import { AlertCircle } from "lucide-react";

interface CompleteProfileFormActionsProps {
  hasErrors: boolean;
  saveErrorMessage?: string | null;
  isComplete: boolean;
  isSubmitting: boolean;
  forceOpen?: boolean;
}

export const CompleteProfileFormActions = ({
  hasErrors,
  saveErrorMessage,
  isComplete,
  isSubmitting,
  forceOpen = false
}: CompleteProfileFormActionsProps) => {
  const showBanner = hasErrors || !!saveErrorMessage;
  const bannerText = saveErrorMessage || "Por favor, revisa los campos marcados en rojo";
  return (
    <>
      {showBanner && (
        <div className="bg-red-500/20 border border-red-500/50 rounded-lg p-3 flex items-center gap-2">
          <AlertCircle className="h-4 w-4 text-red-400 shrink-0" />
          <p className="text-red-400 text-sm">
            {bannerText}
          </p>
        </div>
      )}

      <Button
        type="submit"
        className="w-full bg-[#2196A3] hover:bg-[#00C1D6] text-white transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
        disabled={!isComplete || isSubmitting}
      >
        {isSubmitting ? (
          <div className="flex items-center gap-2">
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
            Guardando...
          </div>
        ) : (
          "Guardar y Continuar"
        )}
      </Button>
      
      {forceOpen && (
        <p className="text-xs text-gray-400 text-center">
          No podrás continuar hasta completar todos los campos
        </p>
      )}
    </>
  );
};
